import { Box, Typography } from "@mui/material";

const SitesConsumptionForm = () => (
  <Box>
    <Typography variant={"h2"}>SitesConsumptionForm</Typography>
    <Typography variant={"body1"}>
      SitesConsumptionForm body copy here
    </Typography>
  </Box>
);

export default SitesConsumptionForm;
